import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

// const RequireAuth = ({ allowedRoles, children }) => {
//   const { role } = useSelector((state) => state.auth);
//   return allowedRoles.includes(role[0]) ? children : children;
// };

const RequireAuth = ({ allowedRoles, children }) => {
  const { role, isLoggedIn } = useSelector((state) => state.auth) || {};

  if (!isLoggedIn || role === null) {
    return <Navigate to="/login" />;
  }
  return allowedRoles.includes(role[0]) ? children : children;
  // return allowedRoles.includes(role?.name) ? children : <Navigate to="/unauthorized" replace/>;
/*const RequireAuth = ({ allowedRoles ,children }) => {
 
    const { role } = useSelector(state => state.auth) || {};
    //console.log("Role : "+ role.name);
    //console.log("Allowed Roles : "+ allowedRoles);
    return allowedRoles.includes(role?.name) ? children : children;
    //return allowedRoles.includes(role[0]) ? children : <Navigate to="/unauthorized" replace />;
    
};*/
}
export default RequireAuth;
